// extracted by mini-css-extract-plugin
module.exports = {"class":"ClassItem_class__38cmr","badge":"ClassItem_badge__1iDNt","name":"ClassItem_name__2AI0P","active":"ClassItem_active__1Q5JM"};